<template>
  <div>
    <FormRadio
      v-if="showAny"
      :class="mbClass"
      :option="null"
      :name="name"
      :index="0"
      :model-value="modelValue"
      :custom-accent-hex="customAccentHex"
      @update:modelValue="updateModelValue(null)"
      :text-class="textClass"
      :readonly="readonly"
    >
      Any
    </FormRadio>
    <FormRadio
      v-for="(option, index) in formattedOptions"
      :key="index"
      :option="option"
      :multiple="multiple"
      :name="name"
      :index="index + 1"
      :model-value="modelValue"
      :custom-accent-hex="customAccentHex"
      :disabled="option.disabled"
      :badge="option.badge"
      @update:modelValue="multiple ? $emit('update:modelValue', $event) : updateModelValue(option)"
      :class="mbClass"
      :text-class="textClass"
      :readonly="readonly"
    />
  </div>
</template>

<script setup>
import FormRadio from "./FormRadio.vue";
import {computed} from "vue";

const emits = defineEmits(["update:modelValue"]);
const props = defineProps({
  modelValue: {
    type: [String, Number, Boolean, Date, Array],
    default: "",
  },
  multiple: Boolean,
  options: {
    type: Array,
    default: () => [],
  },
  name: String,
  hideOptionList: Boolean,
  prefix: String,
  suffix: String,
  showAny: Boolean,
  customAccentHex: String,
  mbClass: {
    type: String,
    default: "mb-1.5",
  },
  textClass: String,
  readonly: Boolean,
});

const formattedOptions = computed(() => {
  return props.options.map((option) => {
    if (typeof option === "object") {
      return {name: option.name, value: option.value, icon: option?.icon, disabled: option?.disabled, badge: option?.badge};
    }
    return {name: (props.prefix || "") + option + (props.suffix || ""), value: option};
  });
});

const updateModelValue = (value) => {
  if (typeof value === "object") value = value?.value;
  emits("update:modelValue", value);
};
</script>
